import axios from "axios";
import { baseurl } from "../../../baseUrl/baseurl.ts";



export const virtualMallLoginApi = async (data) => {
    try {
        const response = await axios.post(`${baseurl}virtualuser/login`, data);
        return response.data;
    } catch (error) {
        console.error("Error fetching virtual mall login:", error);
        throw error;
    }
}

export const virtualMallProfileApi = async () => {
    const token = localStorage.getItem("virtualmall_token");
    try {
        const response = await axios.get(`${baseurl}virtualuser/profile`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.data && error.response.data.status === "token_expired") {
            window.dispatchEvent(new Event('virtualMallTokenExpired'));
            return;
        }
        console.error("Error fetching virtual mall product list:", error);
        throw error;
    }
}

export const virtualMallSingleIdProductsApi = async () => {
    const token = localStorage.getItem("virtualmall_token");
    try {
        const response = await axios.get(`${baseurl}virtualuser/single-id-products`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.data && error.response.data.status === "token_expired") {
            window.dispatchEvent(new Event('virtualMallTokenExpired'));
            return;
        }
        console.error("Error fetching single ID products:", error);
        throw error;
    }
}

export const virtualMallSingleIdProductPurchaseApi = async (formData) => {
    const token = localStorage.getItem("virtualmall_token");
    try {
        const response = await axios.post(`${baseurl}virtualuser/single-id-product/purchase`, formData, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.data && error.response.data.status === "token_expired") {
            window.dispatchEvent(new Event('virtualMallTokenExpired'));
            return;
        }
        console.error("Error submitting single ID product purchase:", error);
        throw error;
    }
}

export const virtualMallSingleIdProductTransactionIdCheckApi = async (transaction_id) => {
    const token = localStorage.getItem("virtualmall_token");
    try {
        const response = await axios.post(`${baseurl}virtualuser/single-id-product/check-transaction-id`, { transaction_id }, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data;
    } catch (error) {
        if (error.response?.data?.status === "token_expired") {
            window.dispatchEvent(new Event('virtualMallTokenExpired'));
            return;
        }
        if (error.response?.status === 409) return error.response.data;
        console.error("Error checking single ID product transaction ID:", error);
        throw error;
    }
}

export const virtualMallSingleIdProductOrderHistoryApi = async () => {
    const token = localStorage.getItem("virtualmall_token");
    try {
        const response = await axios.get(`${baseurl}virtualuser/single-id-product/orders`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data;
    } catch (error) {
        if (error.response?.data?.status === "token_expired") {
            window.dispatchEvent(new Event('virtualMallTokenExpired'));
            return;
        }
        console.error("Error fetching Single ID product purchase history:", error);
        throw error;
    }
}

export const virtualMallSingleIdProductTreeApi = async () => {
    const token = localStorage.getItem("virtualmall_token");
    try {
        const response = await axios.get(`${baseurl}virtualuser/single-id-product/tree`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.data && error.response.data.status === "token_expired") {
            window.dispatchEvent(new Event('virtualMallTokenExpired'));
            return;
        }
        console.error("Error fetching Single IDs Tree:", error);
        throw error;
    }
}

export const virtualMallSingleIdWelcomeCertificatesApi = async () => {
    const token = localStorage.getItem("virtualmall_token");
    try {
        const response = await axios.get(`${baseurl}virtualuser/single-id-product/welcome-certificates`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data;
    } catch (error) {
        if (error.response?.data?.status === "token_expired") {
            window.dispatchEvent(new Event('virtualMallTokenExpired'));
            return;
        }
        console.error("Error fetching Single ID Welcome Certificates:", error);
        throw error;
    }
}

export const virtualMallProfileEditApi = async (data) => {
    const token = localStorage.getItem("virtualmall_token");
    try {
        const response = await axios.post(`${baseurl}virtualuser/edit/profile`, data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.data && error.response.data.status === "token_expired") {
            window.dispatchEvent(new Event('virtualMallTokenExpired'));
            return;
        }
        console.error("Error fetching virtual mall product list:", error);
        throw error;
    }
}

export const virtualMallPurchaseApi = async (formdata) => {
    const token = localStorage.getItem("virtualmall_token");
    try {
        const response = await axios.post(`${baseurl}virtualuser/purchase`,
            formdata,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
        return response.data;
    } catch (error) {
        if (error.response && error.response.data && error.response.data.status === "token_expired") {
            window.dispatchEvent(new Event('virtualMallTokenExpired'));
            return;
        }
        console.error("Error fetching virtual mall purchase:", error);
        throw error;
    }
}

export const virtualMallPurchaseListApi = async (data) => {
    const token = localStorage.getItem("virtualmall_token");
    try {
        const response = await axios.post(`${baseurl}virtualuser/purchase/list`, data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.data && error.response.data.status === "token_expired") {
            window.dispatchEvent(new Event('virtualMallTokenExpired'));
            return;
        }
        console.error("Error fetching virtual mall purchase list:", error);
        throw error;
    }
}

export const virtualMallShopPurchaseListApi = async (data) => {
    const token = localStorage.getItem("virtualmall_token");
    try {
        const response = await axios.post(`${baseurl}virtualuser/shop-purchase/list`, data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.data && error.response.data.status === "token_expired") {
            window.dispatchEvent(new Event('virtualMallTokenExpired'));
            return;
        }
        console.error("Error fetching virtual mall shop purchase list:", error);
        throw error;
    }
}

export const virtualMallPointPurchaseListApi = async (data) => {
    const token = localStorage.getItem("virtualmall_token");
    try {
        const response = await axios.post(`${baseurl}virtualuser/point-purchase/list`, data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.data && error.response.data.status === "token_expired") {
            window.dispatchEvent(new Event('virtualMallTokenExpired'));
            return;
        }
        console.error("Error fetching virtual mall point purchase list:", error);
        throw error;
    }
}

export const virtualMallProductListApi = async () => {
    const token = localStorage.getItem("virtualmall_token");

    try {
        const response = await axios.post(
            `${baseurl}virtualuser/list/products`,
            {}, // request body (empty if not needed)
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return response.data;
    } catch (error) {
        if (error.response && error.response.data && error.response.data.status === "token_expired") {
            window.dispatchEvent(new Event('virtualMallTokenExpired'));
            return;
        }
        console.error("Error fetching virtual mall product list:", error);
        throw error;
    }
};

export const virtualMallUserTreeApi = async (data) => {
    const token = localStorage.getItem("virtualmall_token");
    try {
        const response = await axios.post(`${baseurl}virtualuser/list/user_tree`, data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.data && error.response.data.status === "token_expired") {
            window.dispatchEvent(new Event('virtualMallTokenExpired'));
            return;
        }
        console.error("Error fetching virtual mall user tree:", error);
        throw error;
    }
}

export const UserUnknownTreeApproveApi = async (data) => {
    try {
        const response = await axios.post(`${baseurl}virtualuser/edit/profile`, data,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem("virtualmall_token")}`,
                },
            }
        );
        console.log("User tree approve response:", response.data);
        return response.data;
    } catch (error) {
        console.error("Error fetching User tree approve:", error);
        throw error;
    }
};

export const virtualMallWithdrawalListApi = async () => {
    const token = localStorage.getItem("virtualmall_token");
    try {
        const response = await axios.post(`${baseurl}virtualuser/withdraw/list`, {}, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.data && error.response.data.status === "token_expired") {
            window.dispatchEvent(new Event('virtualMallTokenExpired'));
            return;
        }
        console.error("Error fetching virtual mall withdrawal list:", error);
        throw error;
    }
}

export const virtualMallIncentiveListApi = async () => {
    const token = localStorage.getItem("virtualmall_token");
    try {
        const response = await axios.post(`${baseurl}virtualuser/incentive/wallet/history`, {}, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.data && error.response.data.status === "token_expired") {
            window.dispatchEvent(new Event('virtualMallTokenExpired'));
            return;
        }
        console.error("Error fetching virtual mall incentive list:", error);
        throw error;
    }
}

export const virtualMallRecentTransactionsApi = async () => {
    const token = localStorage.getItem("virtualmall_token");
    try {
        const response = await axios.post(`${baseurl}virtualuser/incentive/recent-transactions`, {}, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.data && error.response.data.status === "token_expired") {
            window.dispatchEvent(new Event('virtualMallTokenExpired'));
            return;
        }
        console.error("Error fetching virtual mall recent transactions:", error);
        throw error;
    }
}

export const virtualMallShopPurchaseIncentiveApi = async () => {
    const token = localStorage.getItem("virtualmall_token");
    try {
        const response = await axios.get(`${baseurl}virtualuser/single-id-product/shop-purchase-incentive`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data;
    } catch (error) {
        if (error.response?.data?.status === "token_expired") {
            window.dispatchEvent(new Event('virtualMallTokenExpired'));
            return;
        }
        console.error("Error fetching Shop Purchase Incentive wallet:", error);
        throw error;
    }
}

export const virtualMallWithdrawApi = async (data) => {
    const token = localStorage.getItem("virtualmall_token");
    try {
        const response = await axios.post(`${baseurl}virtualuser/withdraw/request`, data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.data && error.response.data.status === "token_expired") {
            window.dispatchEvent(new Event('virtualMallTokenExpired'));
            return;
        }
        console.error("Error creating virtual mall withdrawal:", error);
        throw error;
    }
}

export const virtualMallWithdrawRequestApi = async (data) => {
    const token = localStorage.getItem("virtualmall_token");
    try {
        const response = await axios.post(`${baseurl}virtualuser/withdraw/incentive`, data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.data && error.response.data.status === "token_expired") {
            window.dispatchEvent(new Event('virtualMallTokenExpired'));
            return;
        }
        console.error("Error creating virtual mall withdraw request:", error);
        throw error;
    }
}

export const virtualMallChangePasswordApi = async (data) => {
    const token = localStorage.getItem("virtualmall_token");
    try {
        const response = await axios.post(`${baseurl}virtualuser/change/password`, data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.data && error.response.data.status === "token_expired") {
            window.dispatchEvent(new Event('virtualMallTokenExpired'));
            return;
        }
        console.error("Error creating virtual mall change password:", error);
        throw error;
    }
}

export const virtualMallForgetPasswordApi = async (data) => {
    const token = localStorage.getItem("virtualmall_token");
    try {
        const response = await axios.post(`${baseurl}virtualuser/forgot/password`, data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.data && error.response.data.status === "token_expired") {
            window.dispatchEvent(new Event('virtualMallTokenExpired'));
            return;
        }
        console.error("Error creating virtual mall forget password:", error);
        throw error;
    }
}

export const virtualMallVerifyPhoneNumberApi = async (data) => {
    const token = localStorage.getItem("virtualmall_token");
    try {
        const response = await axios.post(`${baseurl}virtualuser/verify/phonenumber`, data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.data && error.response.data.status === "token_expired") {
            window.dispatchEvent(new Event('virtualMallTokenExpired'));
            return;
        }
        console.error("Error creating virtual mall verify phone number:", error);
        throw error;
    }
}

export const virtualMallCheckoutApi = async (data) => {
    const token = localStorage.getItem("virtualmall_token");
    try {
        const response = await axios.post(`${baseurl}virtualuser/cart/checkout`, data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.data && error.response.data.status === "token_expired") {
            window.dispatchEvent(new Event('virtualMallTokenExpired'));
            return;
        }
        console.error("Error in virtual mall checkout:", error);
        throw error;
    }
}

export const forgotTransactionPasswordRequestApi = async () => {
    const token = localStorage.getItem("virtualmall_token");
    try {
        const response = await axios.post(`${baseurl}virtualuser/forgot/transaction-password`, {}, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.data && error.response.data.status === "token_expired") {
            window.dispatchEvent(new Event('virtualMallTokenExpired'));
            return;
        }
        console.error("Error submitting forgot transaction password request:", error);
        throw error;
    }
}
